import React from 'react';
import Contact from '../Contact';
type Props = {};

const ContactContainer = (props: Props) => {
  return <Contact />;
};

export default ContactContainer;
